import { useNavigate } from "react-router-dom";

const GreLandingPage = () => {
  const navigate = useNavigate();

  const handleLoginRedirect = () => {
    navigate("/login-gre");
  };

  return (
    <main style={{ fontFamily: "sans-serif" }}>
      {/* Hero Section */}
      <section
        style={{
          padding: "4rem 1rem",
          textAlign: "center",
          color: "black",
        }}
      >
        <h1
          style={{
            fontSize: "2.75rem",
            fontWeight: "bold",
            marginBottom: "1rem",
          }}
        >
          Track your GRE study time
        </h1>
        <p style={{ fontSize: "1.125rem", marginBottom: "2rem" }}>
          Log sessions, take notes, and measure total progress—all in one place.
        </p>
        <button onClick={handleLoginRedirect} style={styles.primaryButton}>
          Get Started
        </button>
      </section>

      {/* How it Works */}
      <section
        style={{
          padding: "4rem 1rem",
          textAlign: "center",
          backgroundColor: "#f9fafb",
        }}
      >
        <h2
          style={{ fontSize: "2rem", fontWeight: "bold", marginBottom: "2rem" }}
        >
          How it works
        </h2>
        <ol
          style={{
            listStyle: "decimal",
            textAlign: "left",
            maxWidth: "600px",
            margin: "0 auto",
            fontSize: "1.125rem",
            color: "#374151",
            lineHeight: 2,
          }}
        >
          <li>Log in with your Google account</li>
          <li>Click start when you begin studying</li>
          <li>Pause and resume your timer as needed</li>
          <li>Write optional notes for each session</li>
          <li>See your full study history and totals</li>
        </ol>
      </section>
    </main>
  );
};

const styles: Record<string, React.CSSProperties> = {
  primaryButton: {
    padding: "0.75rem 1.5rem",
    fontSize: "1rem",
    backgroundColor: "#3b82f6",
    color: "#fff",
    border: "none",
    borderRadius: "9999px",
    cursor: "pointer",
  },
};

export default GreLandingPage;
